var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visibility === 'public')?_c('Earth',{attrs:{"size":22}}):(_vm.visibility === 'followers')?_c('AccountMultiple',{attrs:{"size":22}}):(_vm.visibility === 'unlisted')?_c('LockOpen',{attrs:{"size":22}}):(_vm.visibility === 'direct')?_c('At',{attrs:{"size":22}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }